import { render, staticRenderFns } from "./ElMenuLinksV3.vue?vue&type=template&id=1abf5f03"
import script from "./ElMenuLinksV3.vue?vue&type=script&lang=js"
export * from "./ElMenuLinksV3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports